import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";

function Featured_service() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <main id="main">
      <section id="featured-services" className="featured-services">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Services</h2>
            <h3>
              Check our <span>Services</span>
            </h3>
            <p>Improve productivity, quality, and customer experience.</p>
          </div>
          <div className="row">
            {/* Service 1 */}
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon">
                  <i className="bx bxl-dribbble"></i>
                </div>
                <h4 className="title">MOBILE APP DEVELOPMENT</h4>
                <p className="description">
                  iOS & Android apps for patient intake, sample tracking, and
                  results.
                </p>
              </div>
            </div>

            {/* Service 2 */}
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon">
                  <i className="bx bx-file"></i>
                </div>
                <h4 className="title">WEB APP DEVELOPMENT</h4>
                <p className="description">
                  Secure, role-based lab portals for staff, providers, and
                  patients.
                </p>
              </div>
            </div>

            {/* Service 3 */}
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div className="icon">
                  <i className="bx bx-tachometer"></i>
                </div>
                <h4 className="title">WEB DEVELOPMENT</h4>
                <p className="description">
                  Fast, accessible websites & CMS tailored to healthcare and
                  diagnostics.
                </p>
              </div>
            </div>

            {/* Service 4 - With Modal */}
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div
                className="icon-box"
                data-aos="fade-up"
                data-aos-delay="300"
                style={{ cursor: "pointer" }}
                onClick={handleShow}
              >
                <div className="icon">
                  <i className="bx bx-analyse"></i>
                </div>
                <h4 className="title">
                  <span>ANALYTICAL SERVICES</span>
                </h4>
                <p className="description">
                  Turn Complex Data into Clear, Actionable Insights
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Analytical Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Our Analytical Services help you go beyond raw numbers. Using
            OpenSource, various Cloud and AI platforms, our advanced analytics
            platform, we transform your unstructured and structured data into
            valuable business intelligence. Whether you’re tracking performance,
            forecasting trends, or uncovering hidden opportunities, our
            solutions put the power of informed decision-making in your hands.
          </p>
          <h6>What We Offer:</h6>
          <ul>
            <li>
              <b>Data Integration & Cleaning</b> – Combine data from multiple
              sources and ensure accuracy.
            </li>
            <li>
              <b>Interactive Dashboards</b> – Visualize KPIs in real-time with
              intuitive, user-friendly views.
            </li>
            <li>
              <b>Predictive Analytics</b> – Identify trends and forecast future
              performance using AI-driven models.
            </li>
            <li>
              <b>Automated Reporting</b> – Get the insights you need without
              manual effort.
            </li>
            <li>
              <b>Qualitative & Quantitative Analysis</b> – Process everything
              from numerical data to survey feedback and text-heavy reports.
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </main>
  );
}

export default Featured_service;
